import React from 'react';
import './LoadTable.css';

const LoadTable = ({ title, loads }) => {
  return (
    <div className="load-table-container">
      <h3>{title}</h3>
      <table className="load-table">
        <thead>
          <tr>
            <th>Load ID</th>
            <th>Origin</th>
            <th>Destination</th>
            <th>Pickup Date</th>
            <th>Rate</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {loads.map(load => (
            <tr key={load.id}>
              <td>{load.id}</td>
              <td>{load.origin}</td>
              <td>{load.destination}</td>
              <td>{load.pickupDate}</td>
              <td>${load.rate}</td>
              <td><button className="book-btn">Book</button></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default LoadTable;